import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
    ModalBody, ModalFooter, Button, Flex, Box, Input, FormLabel, Select, Spinner
} from "@chakra-ui/react";
import { FileCheck } from "lucide-react";
import React, { useState } from 'react';
import useCustomToast from "../../utils/toastHelper";

const GetInTouchModal = ({ isOpen, onClose }) => {

    const [isLoading, setIsLoading] = useState(false);
    const { showSuccessToast, showErrorToast } = useCustomToast();
    const [formData, setFormData] = useState({
        name: "", email: "", mobile: "", company: "", designation: "",
        address: "", contactTime: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { name, email, mobile, company, designation, address, contactTime } = formData;

        // Form validation
        if (!name || !email || !mobile || !company || !designation || !address || !contactTime) {
            showErrorToast("Please fill all the fields before submitting.");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {
            showErrorToast("Please enter a valid email address.");
            return;
        }



        try {
            setIsLoading(true); // Start loader
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/GetInTouch`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                showSuccessToast("Thank you! We'll contact you shortly.");
                // reset form fields
                setFormData({
                    name: "", email: "", mobile: "", company: "", designation: "",
                    address: "", contactTime: ""
                });
            } else {
                showErrorToast(data.message || "Something went wrong.");
            }
        } catch (error) {
            console.error("Submission error:", error);
            showErrorToast("Failed to send request. Please try again.");
        }
        finally {
            setIsLoading(false); // Stop loader once done
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent mt="7vh">
                <ModalHeader>Get In Touch</ModalHeader>
                <ModalCloseButton color="red.500" _hover={{ bg: "transparent" }} />

                <ModalBody>
                    <Flex direction="column" gap="1rem">
                        <Box>
                            <FormLabel>Full Name</FormLabel>
                            <Input
                                placeholder="Full Name"
                                value={formData.name}
                                name="name"
                                onChange={handleChange}
                            />
                        </Box>
                        <Box>
                            <FormLabel>Email</FormLabel>
                            <Input
                                placeholder="Email"
                                value={formData.email}
                                name="email"
                                onChange={handleChange}
                            />
                        </Box>
                        <Box>
                            <FormLabel>Mobile Number</FormLabel>
                            <Input
                                placeholder="Mobile Number"
                                value={formData.mobile}
                                name="mobile"
                                onChange={handleChange}
                            />
                        </Box>
                        <Box>
                            <FormLabel>Company</FormLabel>
                            <Input
                                placeholder="Company"
                                value={formData.company}
                                name="company"
                                onChange={handleChange}
                            />
                        </Box>
                        <Box>
                            <FormLabel>Designation</FormLabel>
                            <Input
                                placeholder="Designation"
                                value={formData.designation}
                                name="designation"
                                onChange={handleChange}
                            />
                        </Box>
                        <Box>
                            <FormLabel>Address</FormLabel>
                            <Input
                                placeholder="Address"
                                value={formData.address}
                                name="address"
                                onChange={handleChange}
                            />
                        </Box>
                        <Box>
                            <FormLabel>Preferred Contact Time</FormLabel>

                            <Select

                                value={formData.contactTime}
                                name="contactTime"
                                onChange={handleChange}
                            >
                                <option value="">-- Select Time --</option>
                                <option value="Morning">Morning</option>
                                <option value="Afternoon">Afternoon</option>
                                <option value="Evening">Evening</option>
                            </Select>

                        </Box>
                    </Flex>
                </ModalBody>

                <ModalFooter>
                    <Button
                        colorScheme="purple"
                        mr={3}
                        onClick={handleSubmit}
                        rightIcon={isLoading ? <Spinner size="sm" /> : <FileCheck size={18} />}
                        isLoading={isLoading}
                        loadingText="Submitting..."
                    >
                        {isLoading ? 'Submitting...' : 'Submit'}
                    </Button>

                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default GetInTouchModal;
